module.exports = __webpack_public_path__ + "img/initial_d_canvas.9487e852.jpg";